import { render, staticRenderFns } from "./NominadosList.vue?vue&type=template&id=81ef3572&"
import script from "./NominadosList.vue?vue&type=script&lang=js&"
export * from "./NominadosList.vue?vue&type=script&lang=js&"
import style0 from "./NominadosList.vue?vue&type=style&index=0&id=81ef3572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports